import LogoDefault from "@/assets/regions/rotherham-logo.svg";
import LogoLow from "@/assets/regions/DrinkCoach-logo.svg";
import { RiskLevel } from "@/model/RiskLevel";
import { DefaultLower } from "@/model/DefaultBanners";
const RotherhamDefault = {
    rawCopy: "For alcohol advice and support in Rotherham, call 'ROADS provided by With You' on 0808&nbsp;1753981",
    logoLink: "https://www.wearewithyou.org.uk/services/rotherham-roads-rotherham-alcohol-and-drug-service/"
};
const RotherhamHighRisk = {
    rawCopy: "For Higher Risk scores we recommend that you cut down your drinking. <strong>Click here to <u>book a free online appointment</u> with an alcohol specialist.</strong>",
    logoLink: "https://drinkcoach.bookinglive.com/book/add/p/22"
};
const RotherhamIncreasingRisk = {
    rawCopy: "For Increasing Risk scores we recommend that you cut down your drinking. <strong>Click here to <u>book a free online appointment</u> with an alcohol specialist.</strong>",
    logoLink: "https://drinkcoach.bookinglive.com/book/add/p/22"
};
export default {
    name: "Rotherham",
    logo: {
        file: LogoDefault,
        width: 2459,
        height: 846
    },
    logoLower: {
        file: LogoLow,
        width: 439,
        height: 223
    },
    // linkToSupportFinder: false,
    hasFreeAppointments: true,
    showServiceInfoOnResultsSummaryPage: true,
    bannerInfo: {
        default: RotherhamDefault,
        [RiskLevel.Lower]: DefaultLower,
        [RiskLevel.Increasing]: RotherhamIncreasingRisk,
        [RiskLevel.Higher]: RotherhamHighRisk,
        [RiskLevel.High]: RotherhamDefault
    },
    clinics: [
        {
            name: "ROADS provided by With You",
            isPrimaryProvider: true,
            alwaysShowInResults: true,
            description: "Contact ${name}: ${phone}</a>",
            phone: ["0808 1753981"],
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 2000 }],
                        friday: [{ start: 900, end: 1700 }],
                        saturday: [{ start: 900, end: 1300 }]
                    }
                }
            ],
            address: "Carnson House, 1 Moorgate Road, Rotherham, S60 2EN",
            location: { lat: 53.4276442, lng: -1.3564173 },
            website: "https://www.wearewithyou.org.uk/services/rotherham-roads-rotherham-alcohol-and-drug-service/"
        },
        {
            name: "DrinkCoach Online Appointment with an alcohol specialist",
            alwaysShowFirst: true,
            showAtRiskLevel: [RiskLevel.Higher, RiskLevel.Increasing],
            other_info: "Daytime, evening and weekend appointments available.<br><br>" +
                "People that live in Rotherham are eligible for up to 6 free Online Coaching sessions to help reduce their drinking.<br><br>" +
                "The service is free and confidential.  Get support to cut down or take a break from drinking.",
            alwaysShowInResults: true,
        }
    ]
};
//# sourceMappingURL=Rotherham.js.map